import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_TRIALTYPES_LOAD,
    ACTION_TRIALTYPES_LOAD_BY_ID,

    ACTION_TRIALTYPES_SAVE,

    ACTION_TRIALTYPES_CREATE,

    ITrialTypeLoadAction,
    ITrialTypeLoadByIdAction,
    ITrialTypeLoadFailureAction,
    ITrialTypeLoadSuccessAction,

    ITrialTypeSaveAction,
    ITrialTypeSaveSuccessAction,
    ITrialTypeSaveFailureAction,

    ITrialTypeCreateAction,
    ITrialTypeCreateSuccessAction,
    ITrialTypeCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/trialType";
import { trialTypesApi } from "../services/trialTypes";


export const
    getTrialTypesEpic = (action$): Observable<ITrialTypeLoadSuccessAction | ITrialTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_LOAD)
            .mergeMap((action: ITrialTypeLoadAction) => {
                return trialTypesApi
                    .getTrialTypes()
                    .map(response =>
                        LoadSuccess(response.trialTypes, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialTypeByIdEpic = (action$): Observable<ITrialTypeLoadSuccessAction | ITrialTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_LOAD_BY_ID)
            .mergeMap((action: ITrialTypeLoadByIdAction) => {
                return trialTypesApi
                    .getTrialTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialType, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialTypeEpic = (action$): Observable<ITrialTypeSaveSuccessAction | ITrialTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_SAVE)
            .mergeMap((action: ITrialTypeSaveAction) => {
                return trialTypesApi
                    .setTrialType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialTypeEpic = (action$): Observable<ITrialTypeCreateSuccessAction | ITrialTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALTYPES_CREATE)
            .mergeMap((action: ITrialTypeCreateAction) => {
                return trialTypesApi
                    .createTrialType()
                    .map(response =>
                        CreateSuccess(
                            response.trialType,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



